<script>
export default {
  methods: {
    onSubmit() {
      this.$emit('submit')
    },
  },
}
</script>

<template>
  <div class="flex flex-1 items-center justify-center">
    <div class="p-4 sm:p-8 rounded w-300 sm:bg-white sm:border sm:shadow">
      <router-link
        tag="div"
        :to="{ name: 'login' }"
        class="flex justify-center cursor-pointer mb-2"
      >
        <img src="~@assets/images/logo.svg" alt="NV logotipas" class="w-40" />
      </router-link>

      <h1
        class="mb-8 font-bold text-2xl text-center text-gray-700 tracking-wide"
      >
        <slot name="title"></slot>
      </h1>

      <slot />
    </div>
  </div>
</template>
